export const notificationInteractionFactory = ({
  deliveryMethod,
  originName,
  templateId,
  typeId
}, {
  ctaProxyUrl
}) => ({
  link: ctaProxyUrl,
  'notification-template-id': templateId,
  'delivery-method': deliveryMethod,
  'notification-origin-name': originName || 'no origin name',
  'notification-type-id': typeId
});